import { render } from "./Grade.vue?vue&type=template&id=0a23aa2d&scoped=true"
import script from "./Grade.vue?vue&type=script&lang=js"
export * from "./Grade.vue?vue&type=script&lang=js"

import "./Grade.vue?vue&type=style&index=0&id=0a23aa2d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a23aa2d"]])

export default __exports__